export const HEALTH_HISTORY_ADULT_SURVEY_SYSTEM_NAME = '1';
export const HEALTH_HISTORY_PEDIATRIC_SURVEY_SYSTEM_NAME = '2';
export const TRAVEL_SURVEY_SYSTEM_NAME = '3';
export const ONE_MEDICAL_MEMBERSHIP_PURCHASE_PHONE_NUMBER = '888-888-6373';
export const SENIOR_HEALTH_TRAVEL_SURVEY_MESSAGE = `Thanks for reaching out about your interest in travel recommendations. We recommend visiting a local travel clinic to prepare for your upcoming trip. I've included reliable travel clinic recommendations below.

In case you're curious about why we're recommending this, insurance doesn't normally cover office visits to discuss travel and there are limitations with virtual consultations for travel.

Travel Clinics:
* [Travel Clinics associated with local Departments of Public Health](https://www.cdc.gov/public-health-gateway/php/communications-resources/accredited-health-departments.html)
* [Passport Health](https://www.passporthealthusa.com/)
* Participating Pharmacy Travel Clinics (Ex: [Walgreens](https://www.walgreens.com/topic/immunization-services/travel-health.jsp), [CVS](https://www.walgreens.com/topic/healthcare-clinic/general-health/travel-health.jsp))
* [CDC Accredited Department of Health Sites](https://www.cdc.gov/public-health-gateway/php/communications-resources/accredited-health-departments.html)
* [Clinics providing Yellow Fever Vaccine Services](https://wwwnc.cdc.gov/travel/yellow-fever-vaccination-clinics/search) (if the Yellow Fever vaccine is needed)

Please feel free to reach out to your One Medical office if you have any questions.
`;

export const SURVEY_NAME_TO_MESSAGE_MAP = new Map([[TRAVEL_SURVEY_SYSTEM_NAME, SENIOR_HEALTH_TRAVEL_SURVEY_MESSAGE]]);

// Auth constants
export const AUTH_GUARD_TYPE_NAME = 'AuthGuardService';
export const HIDE_LWA_PARAM_VALUE = 'true';
